import api from '@api'
import janus from '../js/janus'
import Contact from '../js/contact'
import contactCollection from '../js/contactCollection'
import answeredCollection from '../js/answerdCollections'
import callingCollection from '../js/callingCollection'
import log from '../js/customLog'
import { eventBus } from '@eventBus'
import { mapState } from 'vuex'
import workspaceApi from '../../../../api/operatorWorkspace'

export default {
    data () {
        return {
            settings: null,
            janus: null,
            tabIsHidden: false,
            isNoising: false,

            telStatus: false,
            telloading: true,
            textError: false,
            janusErrorCounter: 0,
            pingInterval: null,
            reconnectTimer: null,
            isCanMakeNoice: true
        }
    },
    mounted () {
        document.addEventListener("visibilitychange", function() {
            if (!document.hidden) {
                this.stopBlinkingTitle();
            }
        }.bind(this));
        this.console = new log({name: 'tel'})
    },
    computed: {
        ...mapState({
            user: state => state.profile.user,
        }),
    },

    methods: {
        
        initTel() {
            // прошлый сеанс обязательно освобождаем: иначе на каждой переинициализации
            // копится ещё один Janus-сеанс с параллельной SIP-регистрацией того же абонента
            if(this.janus) {
                try {
                    this.janus.destroy()
                } catch (error) {
                    console.error('initTel: destroy предыдущего сеанса', error)
                }
                this.janus = null
            }

            return this.getSettings().then(janusSettings=>{

                // if(janusSettings.is_disabled) {
                //     this.telHidde = true
                //     throw {ret:false, msg: 'телефония отключена'}
                //     return
                // }
                
                const checkedSettings = this.checkSettings(janusSettings)
                if(!checkedSettings.ret) {
                    throw checkedSettings
                }
                this.janus = new janus({
                    telSettings: janusSettings,
                    emitMessage: this.onmessage,
                    addAudio: this.addAudio,
                    registrationFailed: this.registrationFailed,
                    registered: this.registered,
                    error: this.handleJanusError,
                    destroyed: this.destroyed
                })
                console.log('tel debug: janus', this)
                if(!this.janus.janus) {
                    throw {ret:false}
                    return
                }
                this.contactCollection = new contactCollection()
                this.answeredCollection = new answeredCollection()
                this.callingCollection = new callingCollection()
                this.agentName = janusSettings.id
            })
        },
        handleJanusError(error) {
            console.error('handleJanusError', error, {tel:this})
            this.telStatus = false;
            this.textError = error;
            this.telloading = true;

            let time = 5000
            this.janusErrorCounter++
            if(this.janusErrorCounter > 3) {
                this.$toast.error('Потеряно соединение с телефонией. Попробуйте обновить страницу.');
                time = 15000
                this.janusErrorCounter = 0
            }
            // несколько ошибок подряд ставили несколько таймеров и запускали
            // параллельные переинициализации
            if(this.reconnectTimer) clearTimeout(this.reconnectTimer)
            this.reconnectTimer = setTimeout(() => {
                this.reconnectTimer = null
                this.initTel()
            }, time)

        },
        checkSettings(telSettings) {
            let ret = true
            let msg = ''
            const obj = telSettings
            for (const key in obj) {
                const value = obj[key];

                switch (key) {
                    case 'id':
                        if(!value) {
                            this.console.error('ID is empty',{key,value});
                            msg += 'Агент не указан'
                            ret = false
                        }
                    break;
                    case 'ip':
                        if(!value) {
                            this.console.error('IP is empty',{key,value});
                            ret = false
                        }
                    break;
                    case 'password':
                        if(!value) {
                            this.console.error('Password is empty',{key,value});
                            msg += ' Пароль не указан'
                            ret = false
                        }
                    break;
                    case 'port':
                        if(!value) {
                            this.console.error('Port is empty',{key,value});
                            ret = false
                        }
                    break;
                    case 'wss_url':
                        if(!value) {
                            this.console.error('wss_url is empty',{key,value});
                            ret = false
                        }
                    break;
                    default:
                        if(!value) {
                            this.console.error('Unknown field', {key, value});
                        }
                    break;
                }
            }
            return {ret, msg}
        },
        registered() {
            this.telStatus = true
            this.telloading = false
            this.makeSocketPing()
        },
        
        registrationFailed(reason) {
            this.telStatus = false
            this.telloading = false
            this.textError = reason
        },
        onmessage(action, plugin, janinfo) {
            console.log('tel debug: onmessage',action, plugin, janinfo);
            let contact = null
            switch (action) {
                case "incomingcall":
                    this.handleIncomingCall(plugin, janinfo)
                    contact = this.contactCollection.getByPluginId(plugin.id) 
                    break;
                case 'calling': 
                    this.handleCalling(plugin, janinfo)
                    break;
                case "hangup":
                    contact = this.contactCollection.getByPluginId(plugin.id) 
                    if(!contact) contact = this.answeredCollection.getByPluginId(plugin.id)
                    this.handleHangup(plugin,janinfo)
                    break;
                case 'accepted':
                    contact = this.answeredCollection.getByPluginId(plugin.id) 
                    this.handleAccepted(plugin, janinfo)
                    break;
                default:
                    break;
            }
            this.makeSocketEmit(action, plugin, janinfo, contact)
        },
        
        makeSocketEmit(action, plugin, janinfo, contact) {
            const dict = {
                incomingcall: 'call_incoming',
                //calling: 'calling',
                hangup: 'call_incoming_end',
                accepted: 'call_incoming_end'
            }
            if(!dict[action]) return
            const data = {
                action: dict[action], 
                user_id: this.user.id, 
                call_id: contact.external_call_id,
                phone: contact.number
            }
            console.log(data)
            eventBus.$emit('socketEmit_telList_callEvent', {
                method: 'send', data
            })
        },

        async makeCall(value, workspaceCompanyId = null) {
            try {
                const workspace = this.$store.state.operatorWorkspace
                const inWorkspace = this.$route.name === 'OperatorWorkspace'
                const companyId = workspaceCompanyId || (inWorkspace ? workspace.tabs[workspace.activeKey]?.company_id : null)
                if (inWorkspace && !companyId) throw new Error('Выберите компанию в рабочем месте')
                const callContext = companyId ? (await workspaceApi.prepareCall(companyId, value)).data : null
                const dial = callContext?.dial_string || ((await this.getCurrentCompanyId()) + '*' + value)
                const newcalling = await this.janus.makeCall(dial)
                newcalling.workspaceContext = callContext
                this.callingCollection.add(newcalling)
            } catch (error) {
                console.error('makeCall', error)
                this.$toast.error(error.message || 'Не удалось начать исходящий звонок')
            }
        },

        getCurrentCompanyId() {
            return api.profile.companyInfo().then(res => {
                return res.response.company_id
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
            })
        },

        handleIncomingCall(plugin, janinfo) {
            // plugin = new Date().getTime()
            // janinfo.msg = {
            //     "sip": "event",
            //     "result": {
            //         "event": "incomingcall",
            //         //"username": "sip:+77782503592@89.184.65.45",
            //         //"displayname": "\"Kazakhstan\"",
            //         "call_id": "4f1942f0405445b05af9fa5b2794e9c0@89.184.65.45:5060",
            //         "username": "sip:+380977000006@89.184.65.45",
            //         "displayname": "\"Alga\"",
            //         "callee": "sip:417@167.235.51.139:46817;transport=udp"
            //     },
            //     "call_id": "4f1942f0405445b05af9fa5b2794e9c0@89.184.65.45:5060"
            // }
            // console.log('tel debug: result:', janinfo.msg.result);
            // const randomPart = Math.floor(100000 + Math.random() * 900000);
            // const fake = {
            //     result: {
            //         "username": `sip:+380977${randomPart}@89.184.65.45`,
            //         "displayname": randomPart /2 < 450000 ? "\"Kazakhstan\"" : "\"Alga\""
            //     }
            // }
            // const fake = {
            //     result: {
            //         "username": `sip:+380977${randomPart}@89.184.65.45`,
            //         //"username" : `sip:+77070696252@89.184.65.45`,
            //         "displayname": "\"Alga\""
            //     }
            // }
            // janinfo.msg.result = { ...janinfo.msg.result,...fake.result }
            const contact = new Contact({
                plugin, janinfo, janus: this.janus
            })

            this.contactCollection.add(contact)

            this.alarmNewCall()
            this.blinkingTitle()

        },

        handleCalling(plugin, janinfo) {
            console.log('tel debug: handleCalling', plugin, janinfo );
            const callingContact = this.callingCollection.getById(plugin.id)
            janinfo.msg.result= {
                "event": "calling",
                "username": `sip:${callingContact.phoneNumber}@89.184.65.45`,
            }
            const contact = new Contact({
                plugin, janinfo, janus: this.janus
            })
            contact.client.name = 'Набранный номер'
            contact.settings.workspaceContext = callingContact.workspaceContext || null
            if (callingContact.workspaceContext) {
                this.$store.commit('operatorWorkspace/call', { ...callingContact.workspaceContext, plugin_id: plugin.id, external_call_id: contact.settings.external_call_id || contact.callId })
            }
            //this.contactCollection.add(contact)

            this.answeredCollection.add(contact)
            this.callingCollection.remove(plugin.id)
        },

        handleHangup(plugin, janinfo) {
            const workspaceCall = this.$store.state.operatorWorkspace.call
            if (workspaceCall && (workspaceCall.plugin_id === plugin.id || workspaceCall.external_call_id === janinfo?.msg?.call_id)) {
                this.$store.commit('operatorWorkspace/call', null)
            }
            const contact = this.answeredCollection.getByPluginId(plugin.id)
            //TODO: temp remove this region
            const temp = this.contactCollection.getByPluginId(plugin.id)
            console.log('tel debug: remove contact', {temp}, );
            //end temp remove this region
            const reason = this.getReason(janinfo?.msg?.result)
            
            this.contactCollection.remove(janinfo.msg.call_id, reason)
            this.answeredCollection.deleteByCallId(janinfo.msg.call_id)

            if(janinfo.msg.result.code === 200 && !contact.isTmakeTransfered) {
                eventBus.$emit('endCall');
            }
        },

        getReason(result) {
            return {
                code: result.code,
                reason: result.reason,
                reason_header: result.reason_header || null,
                reason_header_cause: result.reason_header_cause || null,
                reason_header_protocol: result.reason_header_protocol || null
            }
        },

        getSettings() {
            return api.profile.info().then(res=>{
                if(res.response.telephony_info) this.telHidde = false
                return res.response.telephony_info
            }).catch(error=>{
                this.$toast.error(error.message)
                return error
            }).finally(e=>{
                this.isloading = false
            })
        },

        acceptIncoming(contact) {
            this.janus.acceptIncomingCall(contact.plugin, contact.janinfo.jsep)
            this.contactCollection.deleteByCallId(contact.janinfo.msg.call_id)
            this.answeredCollection.add(contact)
        },

        handleAccepted(plugin) {
            const contact = this.answeredCollection.getByPluginId(plugin.id)
            contact.accepted = true
            if(this.answeredCollection.length > 1) {
                // contact.muteAudio()
            }
        },

        addAudio(id, audio) {
            this.answeredCollection.pushAudio(id, audio)
        },

        async HangupCall(contact) {
            await this.janus.makehangup(contact.item.plugin)
            this.contactCollection.deleteByCallId(contact.item.call_id)
            this.handleHangup(contact.item.janinfo)
        },

        alarmNewCall() {
            if(!!this.answeredCollection.length || !this.isCanMakeNoice ) return
            this.makeNoice()
        },
        
        makeNoice() {
            if(this.isNoising) return
            const sound = new Audio('/sound/ring.mp3');
            sound.volume = 0.13;

            sound.play().catch(err => {
                console.warn('Не удалось воспроизвести звук:', err);
                this.isNoising = false;
            });
            this.isNoising = true;
            sound.addEventListener('ended', () => {
                this.isNoising = false;
            });
        },

        blinkingTitle() {
            if(document.hidden) {
                this.startBlinkingTitle()
            }
        },

        startBlinkingTitle() {
            const favicon = document.querySelector('link[rel="icon"]')
            if(!favicon.dataset.dafaultFavicon) favicon.dataset.dafaultFavicon = favicon.href
            if(this.interval) return
            this.interval = setInterval(() => {
                const counter = this.answeredCollection.length
                const digitFavicon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%23FF7F7F'/%3E%3Ctext x='50' y='58' font-weight='800' font-family='Arial, sans-serif' font-size='46' fill='white' text-anchor='middle'%3E"+counter+"%3C/text%3E%3C/svg%3E"
                if (document.title === this.$route.meta.title) {
                    document.title = 'Входящий вызов: ' + counter;
                    favicon.href = digitFavicon
                } else {
                    document.title = this.$route.meta.title;
                    favicon.href = favicon.dataset.dafaultFavicon
                }

                if(!counter){
                    this.stopBlinkingTitle()
                }
            }, 1000);
        },

        stopBlinkingTitle() {
            const favicon = document.querySelector('link[rel="icon"]')
            clearInterval(this.interval);
            this.interval = null;
            document.title = this.$route.meta.title;
            favicon.href = favicon.dataset.dafaultFavicon
        },

        handleTabCalling(data) {
            this.makeCall(data.phoneNumber, data.workspaceCompanyId)
        },
        async maketransferCall(item) {
            const contact = this.answeredCollection.getByPluginId(item.plugin.id)
            if (this.$route.name === 'OperatorWorkspace' || contact?.settings.workspaceContext) {
                try {
                    const id = contact.settings.external_call_id || contact.callId
                    const route = (await workspaceApi.transferCall(id, Number(item.number))).data
                    await this.janus.makeTransfe({ ...item, number: route.sip_number })
                    contact.isTmakeTransfered = true
                } catch (error) { this.$toast.error(error.message) }
                return
            }
            contact.isTmakeTransfered = true

            const company_id = await this.getCurrentCompanyId()
            item.number = company_id+'*'+this.agentName+'*'+item.number 
            await this.janus.makeTransfe(item)
            

        },
        async dtmfTransferCall(item) {
            const contact = this.answeredCollection.getByPluginId(item.plugin.id)
            if (this.$route.name === 'OperatorWorkspace' || contact?.settings.workspaceContext) {
                try {
                    const route = (await workspaceApi.transferCall(contact.settings.external_call_id || contact.callId, Number(item.number))).data
                    await this.janus.makeDtmfTransfer({ ...item, number: route.dtmf_number })
                } catch (error) { this.$toast.error(error.message) }
                return
            }
            const company_id = await this.getCurrentCompanyId()
            item.number = '*2'+company_id+'*'+item.number
            const newdtmf = await this.janus.makeDtmfTransfer(item)
        },

        makeSocketPing() {
            const _now = new Date().getTime()
            if(!this.pingInterval || _now - this.pingInterval >= 20000 ) {
                this.pingInterval = _now
                eventBus.$emit('socketEmit_telList', {method: 'send', data:{action: 'action_ping', user_id: this.user.id}})
            }
        },
        destroyed() {
            
            console.log('tel debug: 8003 destroyed');
        },

        changeNoise() {
            this.isCanMakeNoice = !this.isCanMakeNoice
            localStorage.setItem('isCanMakeNoice', this.isCanMakeNoice)
        }
    }
}
